<template>
    <div>
        <hts-data-table
            :server="server"
            :headers="headerHistoryList"
            :master-detail="true"
            :is-row-master="isRowMaster"
            :detail-row-height="500" />
    </div>
</template>

<script lang="ts" setup>
const { $formatters } = useNuxtApp()
const server = ref({})
const store = $store()
onMounted(() => {
  server.value = $urlAdmin.node.getHistory
})

const headerHistoryList = [
  {
    field: 'name',
    headerName: $t('labels.nodeModule.name'),
    sortable: true
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.companyHistory.dateChanges'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'createdBy',
    headerName: $t('labels.companyHistory.userCreate'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.createdBy) {
        return ''
      }
      return checkName(params.data.createdBy)
    }
  },
  {
    field: 'updatedBy',
    headerName: $t('labels.companyHistory.userChange'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.updatedBy) {
        return ''
      }
      return checkName(params.data.updatedBy)
    }
  },
  {
    field: 'action',
    minWidth: 120,
    maxWidth: 120,
    headerName: $t('labels.companyHistory.action'),
    sortable: true,
    valueGetter: (params: any) => {
      return checkAction(params)
    }
  }
]
const checkName = (id: string) => {
  const users: any[] = store.system.workspaceUsers
  if (users.length === 0) {
    return null
  }
  const user: { [key: string]: any } = computed(() => {
    return users.find((u) => u.user === id)
  })
  return user.value.fullName
}
const checkAction = (params: { [key: string]: any }) => {
  let action = params.data.action
  switch (action) {
  case 'CREATE':
    action = $t('labels.create')
    break
  case 'UPDATE': {
    action = $t('labels.update')
    break
  }
  case 'DELETE':
    action = $t('labels.delete')
    break
  default:
    break
  }
  return action
}
const isRowMaster = (dataItem: any) => {
  if (dataItem.action === 'CREATE' || dataItem.action === 'DELETE') {
    return false
  }
  return true
}
</script>
